// PLAN.md §7.2, §7.3 — single cell on the field.

import type { CellNonSpectator } from '@trading-grounds/shared'
import { CellHeader } from './CellHeader.js'
import { CellCrowd } from './CellCrowd.js'
import { CellAction } from './CellAction.js'
import { useStore } from '../../store.js'

const BG_FOR_DIRECTION: Record<'short' | 'long', string> = {
  short: 'bg-red/5',
  long: 'bg-green/5',
}

export function Cell({ cell }: { cell: CellNonSpectator }) {
  const self = useStore((s) => s.self)
  const direction = cell.startsWith('short') ? 'short' : 'long'

  const isMyCell =
    self?.active_cell === cell || self?.optimistic_target === cell

  return (
    <section
      className={`flex flex-col flex-1 min-h-0 rounded-md p-3 gap-2 ${BG_FOR_DIRECTION[direction]} ${
        isMyCell ? 'ring-1 ring-black/30' : ''
      }`}
    >
      <CellHeader cell={cell} />
      <div className="flex-1 flex items-center justify-center">
        <CellCrowd cell={cell} />
      </div>
      <CellAction cell={cell} />
    </section>
  )
}
